var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationBell({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 14.0002H9.33333C9.33333 14.7335 8.73333 15.3335 8 15.3335C7.26667 15.3335 6.66667 14.7335 6.66667 14.0002ZM14 12.6668V13.3335H2V12.6668L3.33333 11.3335V7.3335C3.33333 5.26683 4.66667 3.46683 6.66667 2.86683V2.66683C6.66667 1.9335 7.26667 1.3335 8 1.3335C8.73333 1.3335 9.33333 1.9335 9.33333 2.66683V2.86683C11.3333 3.46683 12.6667 5.26683 12.6667 7.3335V11.3335L14 12.6668ZM11.3333 7.3335C11.3333 5.46683 9.86667 4.00016 8 4.00016C6.13333 4.00016 4.66667 5.46683 4.66667 7.3335V12.0002H11.3333V7.3335Z",
    fill: "#797979"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBell);
export default __webpack_public_path__ + "static/media/notification-bell.8e797ef8e7e2bd82cdbeb1e8cbba1c68.svg";
export { ForwardRef as ReactComponent };